import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { AtividadeChecklistItemModule } from '../../../../atividade/checklist-item';

import { ClienteRevisaoConfirmarComponent } from './cliente-revisao-confirmar.component';

@NgModule({
    imports: [
        SharedModule,
        AtividadeChecklistItemModule
    ],
    declarations: [
        ClienteRevisaoConfirmarComponent
    ],
    exports: [
        ClienteRevisaoConfirmarComponent
    ]
})
export class ClienteRevisaoConfirmarModule { }
